import { render, staticRenderFns } from "./DHLLabel.vue?vue&type=template&id=5cdae69c&scoped=true"
import script from "./DHLLabel.vue?vue&type=script&lang=js"
export * from "./DHLLabel.vue?vue&type=script&lang=js"
import style0 from "./DHLLabel.vue?vue&type=style&index=0&id=5cdae69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdae69c",
  null
  
)

export default component.exports